export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-play-circle-01f1f1530793decb11eedc2e1e2a2b2f.svg";